export default{func:"function"};